import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

class ExcludeOutletApprovalPopUp extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    handleClose = () => {
        this.props.flagHandle()
    };
    render() {
        return (
            <div className='endstock-table' >
                < Modal
                    className='modal'
                    open={this.props.isOpen}
                    onClose={this.handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.props.isOpen} >
                        <div className='endstock-table ' id="scrollbar" style={{
                            width: '56%', background: 'white',
                            padding: '20px',
                            height: '30%',
                            borderRadius: '5px',
                            outline:'none'
                        }}>
                            <TableContainer style={{width:'100%',overflowY:'auto',boxShadow:'none' }} className='table-main' id="div2" component={Paper}>
                                    <Table stickyHeader aria-label="sticky table" >
                                        <TableHead className='es-table-head'>
                                            <TableRow>
                                                <TableCell className='table-header-td'>Outlet Code</TableCell>
                                                <TableCell className='table-header-td'>Outlet Name</TableCell>
                                                <TableCell className='table-header-td'>Region</TableCell>
                                            </TableRow>
                                        </TableHead>
                                            <TableBody>
                                            {this.props.data?this.props.data.map((item,ind)=>(
                                                <TableRow key={ind}>
                                                    <TableCell align="center" style={{fontSize:'13px',fontFamily:"Source Sans Pro"}}>{item.Code}</TableCell>
                                                    <TableCell align="center" style={{fontSize:'13px',fontFamily:"Source Sans Pro"}}>{item.Description}</TableCell>
                                                    <TableCell align="center" style={{fontSize:'13px',fontFamily:"Source Sans Pro"}}>{item.Region_name}</TableCell>
                                                </TableRow>
                                            )):null}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                        </div>
                    </Fade>
                </Modal >
            </div >
        )
    }
}
export default ExcludeOutletApprovalPopUp;
